import { FaApple, FaLinux, FaWindows } from "react-icons/fa";
import { Layers } from "lucide-react";
import type { DevicePlatform } from "./devicePlatform";
import "./PlatformFilter.css";

export type PlatformFilterValue = Exclude<DevicePlatform, "other"> | null;

const platformOptions = [
  { platform: "windows", label: "Windows", icon: FaWindows },
  { platform: "mac", label: "Mac", icon: FaApple },
  { platform: "linux", label: "Linux", icon: FaLinux },
] as const;

interface PlatformFilterProps {
  value: PlatformFilterValue;
  onChange: (value: PlatformFilterValue) => void;
}

export default function PlatformFilter({ value, onChange }: PlatformFilterProps) {
  return (
    <div className="platform-filter" role="group" aria-label="Filter by platform">
      {platformOptions.map(({ platform, label, icon: Icon }) => (
        <button
          key={platform}
          type="button"
          className="platform-filter-option"
          data-platform={platform}
          aria-pressed={value === platform}
          aria-label={label}
          title={label}
          onClick={() => onChange(value === platform ? null : platform)}
          data-testid={`button-platform-${platform}`}
        >
          <Icon aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}

interface PlatformGroupToggleProps {
  pressed: boolean;
  onChange: (value: boolean) => void;
}

export function PlatformGroupToggle({ pressed, onChange }: PlatformGroupToggleProps) {
  const label = pressed ? "Show all endpoints in one list" : "Group endpoints by platform";

  return (
    <div className="platform-filter">
      <button
        type="button"
        className="platform-filter-option"
        aria-pressed={pressed}
        aria-label={label}
        title={label}
        onClick={() => onChange(!pressed)}
        data-testid="button-group-by-platform"
      >
        <Layers aria-hidden="true" />
      </button>
    </div>
  );
}
